import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Temporal land use, land cover (LULC) information of a landscape
              provides an overview of the drivers of change, and impacts on the
              socio-ecological system. This necessitates organizing diverse data
              of a landscape, which provides insights into sustainable
              management. Spatial heterogeneity with landscape dynamics
              influences biotic and abiotic processes. The knowledge of LULC
              dynamics aids in assessing the feedback between socio-ecological
              systems across the urban and rural environments. Visualizing
              likely landscape changes through modeling help in the
              decision-making for sustainable landscape management. The current
              chapter accounts changes in LULC patterns of the agrarian district
              Tumkur in Karnataka State, considering temporal remote sensing
              data of three decades, using geospatial techniques and modeling.
              Land use (LU) analyses indicate an increase in horticulture area
              from 0.94% (1989) to 1.02% (2019) due to an increase in commercial
              cropping. An upsurge of built-up cover from 0.02 to 2.11%
              (1989-2019) with the enhanced socio-economic activities with the
              industrialization and infrastructure development across the Tumkur
              to Bangalore highway. Spatial patterns of landscape dynamics
              assessed through spatial matrices highlight of increase in
              urbanization with the loss of agriculture and forest cover in the
              outskirts of the Tumkur city center. Ecologically significant
              regions (ESR) were identified at disaggregated levels through
              composite metrics by integrating bio-geo-climatic, social,
              hydrological, and ecological aspects. The study region is divided
              into 9 km x 9 km grids for computing metrics at disaggregated
              levels. ESR is delineated based on the composite metric of all
              variables, depicts 17 grids (11%) under ESR 1, indicating the
              highest sensitivity, 29% area (46 grids) as ESR2 (higher
              sensitivity), 45% (70 grids) as ESR 3 (high sensitivity), and the
              rest is 15% (24 grids) in ESR 4 (moderate sensitivity). The
              outcome of the current research would provide critical management
              approaches required for managing natural resources and will be
              valuable for policy and planning purposes in pursuing Sustainable
              Development Goals (SDGs) at the regional scale.
            </p>
            <p>
              <strong>Keywords:</strong> Land use Land cover (LULC). Forest
              fragmentation, Prediction, Spatial matrices ESR
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
